window.addEventListener('load', () => {
    const elements = document.querySelectorAll('.FAQComponent');

    elements.forEach(el => {
        const items = el?.querySelectorAll('.faq-content__item');
        if (!items) return;

        const setAnswerHeight = () => {
            items.forEach(item => {
                const answer = item.querySelector<HTMLElement>('.item-answer');
                const answerContent = answer.querySelector('.the_content');
                answer.style.height = `${24 + answerContent?.scrollHeight}px`;
            });
        }

        items.forEach(item => {
            const header = item.querySelector('.item-question');

            setAnswerHeight();

            header?.addEventListener('click', () => {
                item.classList.toggle('active');

                items.forEach(otherItem => {
                    if (otherItem !== item) {
                        otherItem.classList.remove('active');
                    }
                });
            });
        });

        window.addEventListener('resize', () => {
            setAnswerHeight();
        })
    });
});